<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <AddNewWSU title="กรุณากรอกข้อมูล"></AddNewWSU>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddNewWSU from "./AddNewWSU";
export default {
  name: "customerWsuAddNew",
  components: {
    AddNewWSU,
  },
  data() {
    return {
      model: {
        policy_number: "",
        file: "",
        document: "",
        tel: "",
        identity_no: "",
        name_prefix: "",
        name: "",
        address: "",
        province: "",
        district: "",
        sub_district: "",
        contact_start_date: "",
        cover_start_date: "",
        cover_end_date: "",
        tax_due_date: "",
        brand: "",
        license_plate: "",
        body_number: "",
        body_type: "",
        cc: "",
        seat: "",
        weight: "",
        insurance_premium: "",
        created_by: "",
        last_notify: "",
      },
    };
  },
};
</script>
<style scoped></style>
